import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export class DeviceService {
    public screenWidth : number | undefined;   
    static smallScreen = 768;
}
